module.exports = __webpack_public_path__ + "c811509f67469a01e7825faa1fb23495.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2018-11-20/whats-new.html
// module id = 2292
// module chunks = 0